import {ReactNode} from 'react';
import styles from './ScienceCallout.module.css';

type ScienceCalloutProps = {
  label?: string;
  children: ReactNode;
};

export const ScienceCallout = ({label = 'Where Rise Care works', children}: ScienceCalloutProps) => (
  <aside className={styles.callout}>
    <span className={styles.label}>{label}</span>
    <p className={styles.body}>{children}</p>
  </aside>
);

export default ScienceCallout;
